export const X_APP_REQUEST_SOURCE = 'X-App-Request-Source';
export const X_APP_REQUEST_SOURCE_VALUE = 'job_form';
